<div *ngIf="mergeModal?.isShown"
    class="local-backdrop"></div>
<div class="ai-mode-container p-3">
    <div class="ai-glow"></div>
    <div class="no-focus  toggleAiAction"
        [ngClass]="{'animate-ai': animateAI, 'expand': expandAI}">
        <button type="button"
            (click)="exitAIMode()"
            pmdRipple
            pmd-btn-outline
            class="ai-button pmd-btn-outline border-light rounded-pill me-1 btn-outline-dark khr-duplicate-btn w-auto h-auto poinnter-events-none "><svg
                width="12"
                height="12"
                viewBox="0 0 12 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_17975_5453)">
                    <path
                        d="M6.40962 2.83209C6.53022 2.51852 6.59052 2.36173 6.67757 2.31625C6.75303 2.27683 6.84299 2.27683 6.91844 2.31625C7.0055 2.36173 7.0658 2.51852 7.1864 2.83209L7.59983 3.90701C7.73023 4.24603 7.79542 4.41554 7.89681 4.55812C7.98666 4.68449 8.09707 4.7949 8.22344 4.88476C8.36603 4.98614 8.53554 5.05134 8.87456 5.18173L9.94948 5.59516C10.263 5.71577 10.4198 5.77607 10.4653 5.86312C10.5047 5.93857 10.5047 6.02854 10.4653 6.10399C10.4198 6.19104 10.263 6.25135 9.94948 6.37195L8.87456 6.78538C8.53554 6.91577 8.36603 6.98097 8.22344 7.08235C8.09707 7.17221 7.98666 7.28262 7.89681 7.40899C7.79542 7.55157 7.73023 7.72108 7.59983 8.0601L7.1864 9.13503C7.0658 9.4486 7.0055 9.60538 6.91844 9.65086C6.84299 9.69028 6.75303 9.69028 6.67758 9.65086C6.59052 9.60538 6.53022 9.4486 6.40962 9.13503L5.99618 8.0601C5.86579 7.72108 5.8006 7.55157 5.69921 7.40899C5.60935 7.28262 5.49895 7.17221 5.37258 7.08235C5.22999 6.98097 5.06048 6.91577 4.72146 6.78538L3.64654 6.37195C3.33297 6.25135 3.17618 6.19104 3.1307 6.10399C3.09128 6.02854 3.09128 5.93857 3.1307 5.86312C3.17618 5.77607 3.33297 5.71577 3.64654 5.59516L4.72146 5.18173C5.06048 5.05134 5.22999 4.98614 5.37258 4.88476C5.49895 4.7949 5.60935 4.68449 5.69921 4.55812C5.8006 4.41554 5.86579 4.24603 5.99618 3.90701L6.40962 2.83209Z"
                        fill="#212121" />
                    <path d="M2.86685 10.6067V8.29492M1.71094 9.45084H4.02277"
                        stroke="#212121"
                        stroke-width="0.780242"
                        stroke-linecap="round"
                        stroke-linejoin="round" />
                    <path d="M2.86685 3.6712V1.35938M1.71094 2.51529H4.02277"
                        stroke="#212121"
                        stroke-width="0.780242"
                        stroke-linecap="round"
                        stroke-linejoin="round" />
                </g>
                <defs>
                    <clipPath id="clip0_17975_5453">
                        <rect width="11.0968"
                            height="11.0968"
                            fill="white"
                            transform="translate(0.787109 0.435547)" />
                    </clipPath>
                </defs>
            </svg>
            <span class="ms-1">AI Mode</span>
        </button>
        <div class="ai-quick-action">
            <button type="button"
                (click)="exitAIMode()"
                pmd-btn
                pmdRipple
                pmd-btn-outline
                class="btn-sm pmd-btn-icon mx-1 btn-outline-dark ">
                Exit AI Mode
            </button>
            <button type="button"
                (click)="onEmitSaveAndExitConfirmation()"
                [disabled]="!pages.length || isRequestProcessing"
                pmd-btn
                pmdRipple
                class="
                btn-sm
                pmd-btn-icon
                mx-1
                me-md-2
                btn-secondary
                border-transparent">
                Save & Exit
            </button>
        </div>
    </div>
    <div class="product-table-details">
        <pmd-tab-group class="position-relative p2p_tabs_purchase my-3 d-block">
            <pmd-tab class="position-relative"
                id="tab-original"
                [active]="activeTab === 'tab-original'"
                (select)="onTabChange('tab-original')">
                <ng-template pmd-tab-label>
                    <div id="tab-need-action"
                        class="d-flex align-items-center gap-2">
                        <svg width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M11.6673 1.89063V5.33274C11.6673 5.79945 11.6673 6.03281 11.7581 6.21107C11.838 6.36787 11.9655 6.49535 12.1223 6.57525C12.3006 6.66608 12.5339 6.66608 13.0007 6.66608H16.4428M11.6673 14.166H6.66732M13.334 10.8327H6.66732M16.6673 8.32287V14.3327C16.6673 15.7328 16.6673 16.4329 16.3948 16.9677C16.1552 17.4381 15.7727 17.8205 15.3023 18.0602C14.7675 18.3327 14.0674 18.3327 12.6673 18.3327H7.33398C5.93385 18.3327 5.23379 18.3327 4.69901 18.0602C4.2286 17.8205 3.84615 17.4381 3.60647 16.9677C3.33398 16.4329 3.33398 15.7328 3.33398 14.3327V5.66602C3.33398 4.26588 3.33398 3.56582 3.60647 3.03104C3.84615 2.56063 4.2286 2.17818 4.69901 1.9385C5.23379 1.66602 5.93385 1.66602 7.33398 1.66602H10.0105C10.6219 1.66602 10.9277 1.66602 11.2154 1.73509C11.4705 1.79633 11.7143 1.89734 11.938 2.03442C12.1903 2.18902 12.4065 2.40521 12.8389 2.83759L15.4957 5.49444C15.9281 5.92682 16.1443 6.14301 16.2989 6.3953C16.436 6.61898 16.537 6.86285 16.5982 7.11794C16.6673 7.40566 16.6673 7.71139 16.6673 8.32287Z"
                                stroke="#646464"
                                stroke-width="1.5"
                                stroke-linecap="round"
                                stroke-linejoin="round" />
                        </svg>
                        <span>Original</span>
                    </div>
                </ng-template>
                <div id="originalPTTable"
                    class="overflow-auto"></div>
                <div class="d-flex flex-wrap gap-3 justify-content-between info-amount m-auto">
                    <div class="d-flex flex-wrap gap-3">
                        <div class="card-title text-muted mb-sm-2 mb-md-0">
                            Net Total:
                            <strong>
                                {{netTotal}}
                            </strong>
                        </div>
                        <span class="d-none d-sm-inline-flex text-muted">|</span>
                        <div class="card-title text-muted">
                            Total Amount:
                            <strong>
                                {{totalAmount}}
                            </strong>
                        </div>
                    </div>

                    <!-- <div>
                        <app-invoice-pagination [id]="'uploaded-pagination'"
                            [page]="
                        currentPageIndex
                        +
                        1"
                            [count]="pages.length"
                            [pageSize]="1"
                            [pageName]="'record'"
                            (pageChange)="onPageChange($event)">
                        </app-invoice-pagination>
                    </div> -->
                </div>
            </pmd-tab>
            <pmd-tab id="tab-ai-result"
                [active]="activeTab === 'tab-ai-result'"
                (select)="onTabChange('tab-ai-result')"
                *ngIf="isRequestProcessing || canShowAIResults">
                <ng-template pmd-tab-label>
                    <div id="tab-pending"
                        class="d-flex align-items-center gap-2">
                        <svg width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M3.74935 18.3327V14.166M3.74935 5.83268V1.66602M1.66602 3.74935H5.83268M1.66602 16.2493H5.83268M10.8327 2.49935L9.38753 6.25673C9.15253 6.86776 9.03502 7.17327 8.85229 7.43025C8.69034 7.65801 8.49135 7.85701 8.26359 8.01896C8.00661 8.20169 7.70109 8.31919 7.09007 8.5542L3.33268 9.99935L7.09007 11.4445C7.70109 11.6795 8.00661 11.797 8.26359 11.9797C8.49135 12.1417 8.69034 12.3407 8.85229 12.5684C9.03502 12.8254 9.15253 13.1309 9.38754 13.742L10.8327 17.4993L12.2778 13.742C12.5128 13.1309 12.6303 12.8254 12.8131 12.5684C12.975 12.3407 13.174 12.1417 13.4018 11.9797C13.6588 11.797 13.9643 11.6795 14.5753 11.4445L18.3327 9.99935L14.5753 8.5542C13.9643 8.31919 13.6588 8.20169 13.4018 8.01896C13.174 7.85701 12.975 7.65801 12.8131 7.43025C12.6303 7.17327 12.5128 6.86776 12.2778 6.25673L10.8327 2.49935Z"
                                stroke="#646464"
                                stroke-width="1.2"
                                stroke-linecap="round"
                                stroke-linejoin="round" />
                        </svg>
                        <span>AI Result</span>
                    </div>
                </ng-template>
                <div class="ask-ai-processing d-flex flex-column justify-content-center w-100">
                    <!-- AIResultData Table Data -->
                    <div>
                        <div id="AIResultData"
                            class="overflow-auto"
                            [ngClass]="{'d-none': !canShowAIResults}">
                        </div>

                        <div class="ask-ai-inside-wrap text-center my-4"
                            *ngIf="isRequestProcessing">
                            <div class="anim-icon">
                                <video width="110"
                                    height="110"
                                    autoplay
                                    loop>
                                    <source src="../../../../../../../assets/images/ask-ai.mp4"
                                        type="video/mp4">
                                    Your browser does not support the video tag.
                                </video>
                            </div>
                            <div class="selected-input">
                                <div class="ask-ai-value">
                                    <span class="fw-semibold me-1">Processing Your Request..</span>
                                </div>
                                <div class="view-all-request">
                                    <a href="#"
                                        (click)="onCancelAIRequest($event)"
                                        class="link text-primary text-decoration-underline fs-12">
                                        Cancel Request
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div class="ai-empty-state text-center py-5"
                            *ngIf="!isRequestProcessing && !canShowAIResults">
                            <div class="empty-state-icon mb-4">
                                <svg width="80"
                                    height="80"
                                    viewBox="0 0 80 80"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <circle cx="40"
                                        cy="40"
                                        r="40"
                                        fill="#e6b401" />
                                    <path
                                        d="M42.732 25.5547C43.0202 24.7457 43.164 24.3412 43.3838 24.2208C43.5754 24.1145 43.8099 24.1145 44.0015 24.2208C44.2213 24.3412 44.3651 24.7457 44.6533 25.5547L46.3982 30.5601C46.7169 31.4602 46.8763 31.9103 47.1453 32.2721C47.3822 32.5896 47.6809 32.8883 47.9984 33.1252C48.3602 33.3942 48.8103 33.5536 49.7104 33.8723L54.7158 35.6172C55.5248 35.9054 55.9293 36.0495 56.0497 36.2693C56.156 36.4609 56.156 36.6954 56.0497 36.887C55.9293 37.1068 55.5248 37.2509 54.7158 37.5391L49.7104 39.284C48.8103 39.6027 48.3602 39.7621 47.9984 40.0311C47.6809 40.268 47.3822 40.5667 47.1453 40.8842C46.8763 41.246 46.7169 41.6961 46.3982 42.5962L44.6533 47.6016C44.3651 48.4106 44.2213 48.8151 44.0015 48.9355C43.8099 49.0418 43.5754 49.0418 43.3838 48.9355C43.164 48.8151 43.0202 48.4106 42.732 47.6016L40.9871 42.5962C40.6684 41.6961 40.509 41.246 40.24 40.8842C40.0031 40.5667 39.7044 40.268 39.3869 40.0311C39.0251 39.7621 38.575 39.6027 37.6749 39.284L32.6695 37.5391C31.8605 37.2509 31.456 37.1068 31.3356 36.887C31.2293 36.6954 31.2293 36.4609 31.3356 36.2693C31.456 36.0495 31.8605 35.9054 32.6695 35.6172L37.6749 33.8723C38.575 33.5536 39.0251 33.3942 39.3869 33.1252C39.7044 32.8883 40.0031 32.5896 40.24 32.2721C40.509 31.9103 40.6684 31.4602 40.9871 30.5601L42.732 25.5547Z"
                                        fill="#ffffff" />
                                    <path d="M28.8891 54.8892V47.6348M25.2617 51.262H32.5161"
                                        stroke="#ffffff"
                                        stroke-width="2.6"
                                        stroke-linecap="round"
                                        stroke-linejoin="round" />
                                    <path d="M28.8891 32.2283V25.3516M25.2617 28.7899H32.5161"
                                        stroke="#ffffff"
                                        stroke-width="2.6"
                                        stroke-linecap="round"
                                        stroke-linejoin="round" />
                                </svg>
                            </div>
                        </div>
                    </div>

                    <!-- <div class="d-flex justify-content-end"
                        *ngIf="!isRequestProcessing">
                        <app-invoice-pagination [id]="'ai-result-pagination'"
                            class="pe-1 pb-1"
                            [page]="
                        currentPageIndex
                        +
                        1"
                            [count]="pages.length"
                            [pageSize]="1"
                            [pageName]="'record'"
                            (pageChange)="onPageChange($event)">
                        </app-invoice-pagination>
                    </div> -->
                </div>
            </pmd-tab>
        </pmd-tab-group>
        <div class="ai-chat card d-flex justify-content-between border-none">
            <form [formGroup]="promptsForm">
                <div class="ai-prompt-card w-100 d-flex flex-column justify-content-between flex-grow-1 border-none"
                    role="region"
                    aria-label="AI Prompt">
                    <div class="d-flex flex-grow-1 mb-2 flex-sm-wrap flex-md-nowrap">
                        <div class="msg-body w-100">
                            <textarea class="form-control border-0 h-100"
                                placeholder="Split Data of Columns..."
                                aria-label="AI prompt input"
                                formControlName="prompt"
                                rows="4"></textarea>
                        </div>
                        <div class="ai-prompt-header ">
                            <button type="button"
                                class="btn btn-outline-dark btn-sm py-1"
                                pmd-btn-outline
                                pmdRipple
                                aria-pressed="false">
                                <svg width="12"
                                    height="12"
                                    viewBox="0 0 12 12"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <g clip-path="url(#clip0_17975_5453)">
                                        <path
                                            d="M6.40962 2.83209C6.53022 2.51852 6.59052 2.36173 6.67757 2.31625C6.75303 2.27683 6.84299 2.27683 6.91844 2.31625C7.0055 2.36173 7.0658 2.51852 7.1864 2.83209L7.59983 3.90701C7.73023 4.24603 7.79542 4.41554 7.89681 4.55812C7.98666 4.68449 8.09707 4.7949 8.22344 4.88476C8.36603 4.98614 8.53554 5.05134 8.87456 5.18173L9.94948 5.59516C10.263 5.71577 10.4198 5.77607 10.4653 5.86312C10.5047 5.93857 10.5047 6.02854 10.4653 6.10399C10.4198 6.19104 10.263 6.25135 9.94948 6.37195L8.87456 6.78538C8.53554 6.91577 8.36603 6.98097 8.22344 7.08235C8.09707 7.17221 7.98666 7.28262 7.89681 7.40899C7.79542 7.55157 7.73023 7.72108 7.59983 8.0601L7.1864 9.13503C7.0658 9.4486 7.0055 9.60538 6.91844 9.65086C6.84299 9.69028 6.75303 9.69028 6.67758 9.65086C6.59052 9.60538 6.53022 9.4486 6.40962 9.13503L5.99618 8.0601C5.86579 7.72108 5.8006 7.55157 5.69921 7.40899C5.60935 7.28262 5.49895 7.17221 5.37258 7.08235C5.22999 6.98097 5.06048 6.91577 4.72146 6.78538L3.64654 6.37195C3.33297 6.25135 3.17618 6.19104 3.1307 6.10399C3.09128 6.02854 3.09128 5.93857 3.1307 5.86312C3.17618 5.77607 3.33297 5.71577 3.64654 5.59516L4.72146 5.18173C5.06048 5.05134 5.22999 4.98614 5.37258 4.88476C5.49895 4.7949 5.60935 4.68449 5.69921 4.55812C5.8006 4.41554 5.86579 4.24603 5.99618 3.90701L6.40962 2.83209Z"
                                            fill="#212121" />
                                        <path d="M2.86685 10.6067V8.29492M1.71094 9.45084H4.02277"
                                            stroke="#212121"
                                            stroke-width="0.780242"
                                            stroke-linecap="round"
                                            stroke-linejoin="round" />
                                        <path d="M2.86685 3.6712V1.35938M1.71094 2.51529H4.02277"
                                            stroke="#212121"
                                            stroke-width="0.780242"
                                            stroke-linecap="round"
                                            stroke-linejoin="round" />
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_17975_5453">
                                            <rect width="11.0968"
                                                height="11.0968"
                                                fill="white"
                                                transform="translate(0.787109 0.435547)" />
                                        </clipPath>
                                    </defs>
                                </svg>
                                <span class="ai-badge"
                                    aria-hidden="true">AI</span>
                            </button>

                        </div>
                    </div>


                    <div class="ai-prompt-actions d-flex align-items-center w-100 justify-content-between flex-wrap">
                        <div class="ai-chips d-flex gap-2 flex-wra align-items-center">
                            <ng-select id="reason"
                                class="pmd-select pmd-select-outline"
                                appearance="outline"
                                [searchable]="true"
                                placeholder="Select prompt"
                                formControlName="promptOption"
                                (change)="onPromptChange($event)">
                                <ng-option *ngFor="let item of prompts"
                                    [value]="item.id">{{ item.label }}</ng-option>
                            </ng-select>
                            <div class="form-check form-switch pmd-switch d-flex align-items-center ms-2 mb-0"
                                *ngIf="isMultiPage">
                                <input #input
                                    class="form-check-input "
                                    type="checkbox"
                                    role="switch"
                                    checked
                                    formControlName="page">
                                <span class="pmd-switch-on switch-label-caption ms-2 text-nowrap">{{promptF.page.value ?
                                    'All Pages' : 'Current Page'}}</span>
                            </div>

                        </div>

                        <div class="ai-submit-wrap">
                            <button type="submit"
                                class="btn btn-outline-dark btn-sm d-flex align-items-center"
                                pmd-btn-outline
                                pmdRipple
                                aria-label="Submit AI prompt"
                                (click)="onEmitAutoSave()"
                                [disabled]="isRequestProcessing">
                                <span class="me-2">Submit</span>
                                <svg width="14"
                                    height="13"
                                    viewBox="0 0 14 13"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M6.03544 6.31236H2.36877M2.31234 6.50669L0.755723 11.1565C0.633434 11.5218 0.57229 11.7044 0.61617 11.8169C0.654276 11.9146 0.736118 11.9886 0.837106 12.0168C0.953396 12.0493 1.12904 11.9702 1.48033 11.8122L12.6213 6.79872C12.9642 6.64442 13.1356 6.56727 13.1886 6.4601C13.2347 6.36699 13.2347 6.25774 13.1886 6.16462C13.1356 6.05745 12.9642 5.9803 12.6213 5.826L1.47645 0.810843C1.12622 0.65324 0.951102 0.574439 0.834926 0.606764C0.734034 0.634838 0.652199 0.708695 0.613962 0.80619C0.569932 0.918453 0.630423 1.1007 0.751406 1.46521L2.31277 6.16938C2.33355 6.23198 2.34394 6.26329 2.34804 6.2953C2.35168 6.32371 2.35164 6.35247 2.34793 6.38087C2.34375 6.41287 2.33328 6.44414 2.31234 6.50669Z"
                                        stroke="#212121"
                                        stroke-width="1.2"
                                        stroke-linecap="round"
                                        stroke-linejoin="round" />
                                </svg>

                            </button>
                        </div>
                    </div>
                </div>
            </form>
        </div>
        <!-- <div class="ai-chat card d-flex justify-content-between border-none">
            <div class="ai-prompt-card d-flex flex-column justify-content-between flex-grow-1 border-none"
                role="region"
                aria-label="AI Prompt">

                <div class="ai-suggestions mb-3 d-flex align-items-center">
                    <p class="text-muted small me-2 mb-0">Quick Actions:</p>
                    <div class="d-flex flex-wrap gap-2">
                        <button type="button"
                            class="btn btn-sm btn-outline-light text-dark fs-12 rounded-pill"
                            pmd-btn-outline
                            pmdRipple>

                            Extract HSN
                        </button>
                        <button type="button"
                            class="btn btn-sm btn-outline-light text-dark fs-12 rounded-pill"
                            pmd-btn-outline
                            pmdRipple>

                            Split Columns
                        </button>
                        <button type="button"
                            class="btn btn-sm btn-outline-light text-dark fs-12 rounded-pill"
                            pmd-btn-outline
                            pmdRipple>

                            Extract Units
                        </button>
                        <button type="button"
                            class="btn btn-sm btn-outline-light text-dark fs-12 rounded-pill"
                            pmd-btn-outline
                            pmdRipple>

                            Add Narration
                        </button>
                        <button type="button"
                            class="btn btn-sm btn-outline-light text-dark fs-12 rounded-pill"
                            pmd-btn-outline
                            pmdRipple>

                            Calculate Tax
                        </button>
                        <button type="button"
                            class="btn btn-sm btn-outline-light text-dark fs-12 rounded-pill"
                            pmd-btn-outline
                            pmdRipple>

                            Find Discounts
                        </button>
                    </div>
                </div>

                <div class="ai-textarea-wrapper position-relative mb-2">
                    <div class="d-flex align-items-start gap-2">
                        <div class="ai-avatar flex-shrink-0 mt-1">
                            <div class="rounded-circle bg-primary-subtle p-2 d-flex align-items-center justify-content-center"
                                style="width: 32px; height: 32px;">
                                <svg width="16"
                                    height="16"
                                    viewBox="0 0 12 12"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <g clip-path="url(#clip0_17975_5453)">
                                        <path
                                            d="M6.40962 2.83209C6.53022 2.51852 6.59052 2.36173 6.67757 2.31625C6.75303 2.27683 6.84299 2.27683 6.91844 2.31625C7.0055 2.36173 7.0658 2.51852 7.1864 2.83209L7.59983 3.90701C7.73023 4.24603 7.79542 4.41554 7.89681 4.55812C7.98666 4.68449 8.09707 4.7949 8.22344 4.88476C8.36603 4.98614 8.53554 5.05134 8.87456 5.18173L9.94948 5.59516C10.263 5.71577 10.4198 5.77607 10.4653 5.86312C10.5047 5.93857 10.5047 6.02854 10.4653 6.10399C10.4198 6.19104 10.263 6.25135 9.94948 6.37195L8.87456 6.78538C8.53554 6.91577 8.36603 6.98097 8.22344 7.08235C8.09707 7.17221 7.98666 7.28262 7.89681 7.40899C7.79542 7.55157 7.73023 7.72108 7.59983 8.0601L7.1864 9.13503C7.0658 9.4486 7.0055 9.60538 6.91844 9.65086C6.84299 9.69028 6.75303 9.69028 6.67758 9.65086C6.59052 9.60538 6.53022 9.4486 6.40962 9.13503L5.99618 8.0601C5.86579 7.72108 5.8006 7.55157 5.69921 7.40899C5.60935 7.28262 5.49895 7.17221 5.37258 7.08235C5.22999 6.98097 5.06048 6.91577 4.72146 6.78538L3.64654 6.37195C3.33297 6.25135 3.17618 6.19104 3.1307 6.10399C3.09128 6.02854 3.09128 5.93857 3.1307 5.86312C3.17618 5.77607 3.33297 5.71577 3.64654 5.59516L4.72146 5.18173C5.06048 5.05134 5.22999 4.98614 5.37258 4.88476C5.49895 4.7949 5.60935 4.68449 5.69921 4.55812C5.8006 4.41554 5.86579 4.24603 5.99618 3.90701L6.40962 2.83209Z"
                                            fill="#0d6efd" />
                                    </g>
                                </svg>
                            </div>
                        </div>

                        <div class="flex-grow-1 position-relative">
                            <textarea #aiPromptTextarea
                                class="form-control border-1 rounded-3 ps-3 pe-5"
                                placeholder="Ask AI to extract, split, or organize your data..."
                                rows="5"
                                style="resize: none; min-height: 80px;"
                                aria-label="AI prompt input"></textarea>

                            <small
                                class="text-muted position-absolute bottom-0 end-0 me-2 mb-1 w-100 d-flex justify-content-between"
                                style="font-size: 10px;">
                                <div class="text-muted small">
                                    <kbd class="bg-light border px-2 py-1 rounded">Shift</kbd> +
                                    <kbd class="bg-light border px-2 py-1 rounded">Enter</kbd> for new line
                                </div>
                                <span>0/500</span>

                            </small>

                            <button type="button"
                                class="btn btn-primary btn-sm position-absolute end-0 top-0 m-2 rounded-circle p-2"
                                style="width: 36px; height: 36px;"
                                pmdRipple
                                aria-label="Submit AI prompt">
                                <svg width="16"
                                    height="16"
                                    viewBox="0 0 14 13"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M6.03544 6.31236H2.36877M2.31234 6.50669L0.755723 11.1565C0.633434 11.5218 0.57229 11.7044 0.61617 11.8169C0.654276 11.9146 0.736118 11.9886 0.837106 12.0168C0.953396 12.0493 1.12904 11.9702 1.48033 11.8122L12.6213 6.79872C12.9642 6.64442 13.1356 6.56727 13.1886 6.4601C13.2347 6.36699 13.2347 6.25774 13.1886 6.16462C13.1356 6.05745 12.9642 5.9803 12.6213 5.826L1.47645 0.810843C1.12622 0.65324 0.951102 0.574439 0.834926 0.606764C0.734034 0.634838 0.652199 0.708695 0.613962 0.80619C0.569932 0.918453 0.630423 1.1007 0.751406 1.46521L2.31277 6.16938C2.33355 6.23198 2.34394 6.26329 2.34804 6.2953C2.35168 6.32371 2.35164 6.35247 2.34793 6.38087C2.34375 6.41287 2.33328 6.44414 2.31234 6.50669Z"
                                        stroke="white"
                                        stroke-width="1.2"
                                        stroke-linecap="round"
                                        stroke-linejoin="round" />
                                </svg>
                            </button>
                        </div>
                    </div>
                </div>

                <div class="ai-prompt-actions d-flex align-items-center justify-content-between flex-wrap gap-2">
                    <div class="d-flex align-items-center gap-3 flex-wrap">
                        <ng-select id="reason"
                            class="pmd-select pmd-select-outline"
                            style="min-width: 180px;"
                            appearance="outline"
                            [searchable]="false"
                            placeholder="Saved Prompts"
                            [formControl]="prompt">
                            <ng-option value="1">

                                Extract HSN Codes
                            </ng-option>
                            <ng-option value="2">

                                Split Product Names
                            </ng-option>
                            <ng-option value="3">

                                Calculate Totals
                            </ng-option>
                            <ng-option value="4">

                                Format Dates
                            </ng-option>
                        </ng-select>

                        <div class="form-check form-switch pmd-switch d-flex align-items-center">
                            <input class="form-check-input"
                                type="checkbox"
                                role="switch"
                                checked>
                            <span class="pmd-switch-on switch-label-caption ms-2 text-nowrap">Current Page Only</span>
                        </div>
                    </div>

                </div>

                <div class="recent-prompts mt-3 d-flex align-items-center">
                    <p class="text-muted small mb-0 me-2">
                        <span class="material-symbols-outlined me-1"
                            style="font-size: 16px; vertical-align: middle;">history</span>
                        Recent:
                    </p>
                    <div class="d-flex flex-wrap gap-2">
                        <button type="button"
                            class="btn btn-sm btn-light fs-12 text-truncate"
                            style="max-width: 200px;"
                            pmd-btn-outline
                            pmdRipple>
                            Split product descriptions into name and quantity
                        </button>
                        <button type="button"
                            class="btn btn-sm btn-light fs-12 text-truncate"
                            style="max-width: 200px;"
                            pmd-btn-outline
                            pmdRipple>
                            Extract HSN codes from all items
                        </button>
                        <button type="button"
                            class="btn btn-sm btn-light fs-12 text-truncate"
                            style="max-width: 200px;"
                            pmd-btn-outline
                            pmdRipple>
                            Calculate tax amounts for all rows
                        </button>
                    </div>
                </div>
            </div>
        </div> -->
    </div>
</div>